module.exports = __webpack_public_path__ + "media/images/banner_default-4970f2f16d364a6f9e26d336718d2863.png";